/**
 * Shared inset (px) from the map viewport edge for bottom-right UI:
 * BasemapSwitcher (`right` / `bottom`) and Leaflet zoom (via `--map-ui-inset` + CSS).
 * Keep in sync with theme spacing where used (e.g. 32 ≈ spacing(4)).
 */
export const MAP_UI_CORNER_INSET_PX = 32;

/**
 * Shared top bar height for map-side drawers and the map viewport.
 * This matches the liftango AppShell top bar height used by the shell.
 */
export const MAP_UI_TOP_BAR_HEIGHT_PX = 72;

/**
 * Shared width of the fixed right-side map rail strip.
 * Persistent drawers sit beside this strip so their content does not overlap it.
 */
export const MAP_UI_RIGHT_RAIL_WIDTH_PX = 64;
